import { useSearchParams } from 'react-router';
import { errorKeyFromCode } from '../../api/api-error';
import { useMe } from '../../auth/session';
import { Notice } from '../../components/ui/notice';
import { useI18n } from '../../i18n/i18n';
import { GoogleSection } from './google-section';
import { PasswordSection } from './password-section';
import { SessionsSection } from './sessions-section';
import { TwoFactorSection } from './two-factor-section';

/**
 * Безопасность: пароль, второй фактор, вход через Google, активные сессии. Сюда же приводит
 * редирект после привязки Google (`?google=linked`, `?error=`).
 */
export function SecurityPage() {
  const { t } = useI18n();
  const me = useMe();
  const [params] = useSearchParams();
  const profile = me.data;
  if (profile === null || profile === undefined) return null;
  const googleError = params.get('error');
  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold">{t('security.title')}</h1>
      {params.get('google') === 'linked' && (
        <Notice tone="success">{t('profile.google.linked')}</Notice>
      )}
      {googleError !== null && <Notice tone="danger">{t(errorKeyFromCode(googleError))}</Notice>}
      <PasswordSection profile={profile} />
      <TwoFactorSection profile={profile} />
      <GoogleSection profile={profile} />
      <SessionsSection />
    </div>
  );
}
